<template>
  <div class="cart-order-block cart-order-block_pay">
    <div class="cart-order-block__head">
      <div class="cart-order-block__number-wrap">
        <div class="cart-order-block__number">
          3 / 3
        </div>
      </div>
      <h3 class="cart-order-block__title text__subtitle">
        Способ оплаты
      </h3>
    </div>

    <div class="cart-order-block__content form-field" v-if="isPhysical">
      <ItemErrors :errors="errors.payment"/>
      <ul class="cart-order-block__radio-list">
        <li class="cart-order-block__radio-item">
          <div class="cart-order-block__radio">
            <input type="radio" name="payment" v-model.number="payment" id="order_online" value="10">
            <label for="order_online" class="cart-order-block__input-label">
              <span class="cart-order-block__label-title texts_heading-13">
                Оплата онлайн картой
              </span>
              <span class="cart-order-block__label-description text text__small">
                Онлайн-оплата картой
              </span>
            </label>
          </div>
        </li>
        <li class="cart-order-block__radio-item">
          <div class="cart-order-block__radio">
            <input type="radio" name="payment" v-model.number="payment" id="order_credit" value="20">
            <label for="order_credit" class="cart-order-block__input-label">
              <span class="cart-order-block__label-title texts_heading-13">
                Оформить долями
              </span>
              <span class="cart-order-block__label-description text text__small">
                Услуга предоставляется АО «Тинькофф Банк»
              </span>
            </label>
          </div>
        </li>
      </ul>
    </div>
    <div class="cart-order-block__content form-field" v-if="isLegal">
      <ItemErrors :errors="errors.payment"/>
      <ul class="cart-order-block__radio-list">
        <li class="cart-order-block__radio-item">
          <div class="cart-order-block__radio">
            <input type="radio" name="payment" v-model.number="payment" id="order_transfer" value="40">
            <label for="order_transfer" class="cart-order-block__input-label">
              <span class="cart-order-block__label-title text__main">
                Безналичный расчет
              </span>
              <span class="cart-order-block__label-description text text__small">
                Оплата по безналичному расчету применяется только в том случае, если заказ оформляется на юридическое лицо
              </span>
            </label>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import ItemErrors from "./ItemErrors.vue";

export default {
  name: "TheCartOrderPay",
  components: {
    ItemErrors
  },
  computed: {
    ...mapState('order', {
      'payment': 'payment'
    }),
    ...mapState('cart', {
      'checkout': 'checkout',
    }),

    payment: {
      get () {
        return this.$store.state.order.payment
      },
      set (value) {
        this.$store.commit('order/setPayment', parseInt(value, 10))
      }
    },
    errors: {
      get() {
        return this.$store.state.order.errors
      }
    },
    ...mapGetters('order', {
      'isPhysical': 'isPhysical',
      'isLegal': 'isLegal',
    }),
  },
}
</script>

<style lang="scss">

</style>
